import style from './TransactionsList.css';
import Transaction from '../Transaction/Transaction';
import TransactionSkeleton from '../Transaction/TransactionSkeleton';
import { renderIf } from '../../../utils/render.utils';
import useTranslation from '../../../localization/i18n.context';

export default function TransactionsList({
  className = '',
  title,
  transactions = [],
  loading = false,
  ...props
}) {
  const { t } = useTranslation();
  const month = title.match(/\{.+\}/g)[0];

  return (
    <div className={`${className} ${style['transaction-group']}`} {...props}>
      <h3 className={style.title}>
        {t(title, { [month]: t(month.replace(/\{|\}/g, '')) })}
      </h3>
      <div className={style.transactions}>
        {transactions.map((tr, idx) => (
          <Transaction key={idx} transaction={tr} />
        ))}
        {renderIf(loading, <TransactionSkeleton />)}
      </div>
    </div>
  );
}
